export const spacing = {
  // Vertical spacing
  section: "space-y-8 md:space-y-10",
  sectionCompact: "space-y-6 md:space-y-8",
  card: "space-y-5 md:space-y-6",
  cardCompact: "space-y-3 md:space-y-4",
  compact: "space-y-3",
  group: "space-y-2.5",
  tight: "space-y-1.5",
  micro: "space-y-1",
  
  // Horizontal spacing
  inline: "space-x-4",
  inlineCompact: "space-x-2",
  inlineTight: "space-x-1",
  
  // Padding - Card system
  cardPadding: "p-6 md:p-8",
  cardPaddingLarge: "p-8 md:p-10 lg:p-12",
  cardHeader: "px-6 py-5 md:px-8 md:py-6",
  cardContent: "px-6 pb-6 pt-5 md:px-8 md:pb-8 md:pt-6",
  cardFooter: "px-6 py-5 md:px-8 md:py-6",
  
  // Padding - General
  padding: "p-4 md:p-6",
  paddingLarge: "p-6 md:p-8 lg:p-10",
  paddingSmall: "p-3 md:p-4",
  
  // Margins
  sectionMargin: "mb-8 md:mb-10",
  sectionMarginLarge: "mb-12 md:mb-16",
  cardMargin: "mb-6 md:mb-8",
  
  // Container spacing
  container: "px-4 py-6 md:px-6 md:py-8 lg:px-8 lg:py-10",
  containerNarrow: "px-4 py-6 md:px-6 md:py-8",
  
  // Modal spacing
  modalPadding: "py-5 md:py-6",
  modalFormSpacing: "space-y-5 md:space-y-6",
  modalFieldSpacing: "space-y-2.5 md:space-y-3",
  
  // Feature cards
  featureCard: "p-6 md:p-8",
  featureIconMargin: "mb-4 md:mb-6",
  featureContentSpacing: "space-y-3 md:space-y-4",
  
  // Button groups
  buttonGroup: "gap-3 md:gap-4",
  buttonGroupTight: "gap-2",
  
  // Grid gaps
  gridGap: "gap-4 md:gap-6 lg:gap-8",
  gridGapCompact: "gap-3 md:gap-4",
  gridGapTight: "gap-2 md:gap-3",
};
